import config from 'services/table/const';
import Action from './table.action';
import { formatDate } from 'utilities/common';

let table = { ...config };

table.url = '/accounting/closing';
table.columns = {
  monthly: {
    title: 'Bulan',
    sortable: true,
    width: 100,
    component: (row) => {
      return (
        <div className="table-col">
          <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
            {formatDate(row?.monthly, "MM/YYYY")}
          </div>
        </div>
      );
    },
  },

  note: {
    title: 'Keterangan',
    sortable: true,
    width: 100,
    component: (row) => {
      return (
        <div className="table-col">
          <div className="text-ellipsis fs-9 fw-semibold text-uppercase">
            {row?.note}
          </div>
        </div>
      );
    },
  },

  created_by: {
    title: 'Dibuat Oleh',
    width: 60,
    component: (row) => {
      return (
        <div className="table-col">
          <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
            {row?.created_by}
          </div>
          <small className="info text-uppercase">
            {formatDate(row?.created_at)}
          </small>
        </div>
      );
    },
  },

  action: {
    title: '',
    sortable: false,
    width: 50,
    class: 'text-end',
    component: (row) => {
      return <Action data={row} />;
    },
  },
};

export default table;
